import {createValidationIssue} from "@project/i18n";
import {UpdateSupplierOfferBody} from "@project/sdk/engineering/zod";
import type {z} from "zod";

import {supplierOfferValidationMessages} from "../../../messages/supplierOffers.messages";

export const updateSupplierOfferFormSchema = UpdateSupplierOfferBody.superRefine((payload, ctx) => {
  const changes = ["price", "minimumOrderQuantity", "orderQuantityMultiple"] as const;
  const changed = changes.filter((key) => payload[key] !== undefined);
  if (payload.clearTerms !== undefined && payload.clearTerms !== true) {
    ctx.addIssue({
      ...createValidationIssue({id: supplierOfferValidationMessages.clearTrue.id}),
      path: ["clearTerms"],
    });
  }
  if (payload.clearTerms === true && changed.length) {
    ctx.addIssue({
      ...createValidationIssue({id: supplierOfferValidationMessages.clearExclusive.id}),
      path: ["clearTerms"],
    });
  }
  if (payload.clearTerms === undefined && !changed.length) {
    ctx.addIssue(createValidationIssue({id: supplierOfferValidationMessages.changeRequired.id}));
  }
});
export type UpdateSupplierOfferFormPayload = z.output<typeof updateSupplierOfferFormSchema>;
export const draftUpdateSupplierOfferFormSchema = UpdateSupplierOfferBody.partial();
export type DraftUpdateSupplierOfferFormPayload = z.output<
  typeof draftUpdateSupplierOfferFormSchema
>;
